import { render, staticRenderFns } from "./RejectLabelButton.vue?vue&type=template&id=829b3d96&"
import script from "./RejectLabelButton.vue?vue&type=script&lang=js&"
export * from "./RejectLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports